import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { primaryBtnStyleOutline } from "../styles/styling";

export default function LogoutModal({
  showLogoutPrompt,
  onClose,
  onConfirm,
}: {
  showLogoutPrompt: boolean;
  onClose: Function;
  onConfirm: Function;
}) {
  return (
    <Dialog
      open={showLogoutPrompt}
      onClose={() => {
        onClose();
      }}
      aria-labelledby="Logout"
    >
      <DialogTitle id="alert-dialog-title">Logout</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to logout?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
          }}
          color="primary"
          sx={[primaryBtnStyleOutline, { width: "60px" }]}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm();
          }}
          autoFocus
          sx={[primaryBtnStyleOutline, { width: "75px" }]}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
